"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeSkeletonConfigRequestT = exports.ChangeSkeletonConfigRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const skeleton_bone_js_1 = require("../../solarxr-protocol/rpc/skeleton-bone.js");
class ChangeSkeletonConfigRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsChangeSkeletonConfigRequest(bb, obj) {
        return (obj || new ChangeSkeletonConfigRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsChangeSkeletonConfigRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ChangeSkeletonConfigRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    bone() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : skeleton_bone_js_1.SkeletonBone.NONE;
    }
    value() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    static startChangeSkeletonConfigRequest(builder) {
        builder.startObject(2);
    }
    static addBone(builder, bone) {
        builder.addFieldInt8(0, bone, skeleton_bone_js_1.SkeletonBone.NONE);
    }
    static addValue(builder, value) {
        builder.addFieldFloat32(1, value, 0.0);
    }
    static endChangeSkeletonConfigRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createChangeSkeletonConfigRequest(builder, bone, value) {
        ChangeSkeletonConfigRequest.startChangeSkeletonConfigRequest(builder);
        ChangeSkeletonConfigRequest.addBone(builder, bone);
        ChangeSkeletonConfigRequest.addValue(builder, value);
        return ChangeSkeletonConfigRequest.endChangeSkeletonConfigRequest(builder);
    }
    unpack() {
        return new ChangeSkeletonConfigRequestT(this.bone(), this.value());
    }
    unpackTo(_o) {
        _o.bone = this.bone();
        _o.value = this.value();
    }
}
exports.ChangeSkeletonConfigRequest = ChangeSkeletonConfigRequest;
class ChangeSkeletonConfigRequestT {
    constructor(bone = skeleton_bone_js_1.SkeletonBone.NONE, value = 0.0) {
        this.bone = bone;
        this.value = value;
    }
    pack(builder) {
        return ChangeSkeletonConfigRequest.createChangeSkeletonConfigRequest(builder, this.bone, this.value);
    }
}
exports.ChangeSkeletonConfigRequestT = ChangeSkeletonConfigRequestT;
